const currentDate = new Date()
currentDate.setMonth(currentDate.getMonth() - 1)
const year = String(currentDate.getFullYear())
const month = currentDate.toLocaleString("default", { month: "long" })
const currentNewsLetterPath = `/newsletter/${year}/${month}`

// Grouped menu used by the app-bar popup (supports one level of nesting via
// `children`). Other surfaces consume the flat `DymockFamilyMenu` below.
export const DymockFamilyMenuGrouped = [
  { name: "Addresses", routerPath: "/addresses" },
  {
    name: "Travel",
    children: [
      { name: "Non-Rev Travel", routerPath: "/non-rev" },
      { name: "Flight Tracker", routerPath: "/flights" },
      { name: "2027 Cruise Planner", routerPath: "/cruise-planning" },
      { name: "Temples & Airports", routerPath: "/temples" },
    ],
  },
  {
    name: "Temple Tracker",
    url: "https://temple-log-e7d23.web.app/",
    external: true,
  },
  { name: "Mom Stories", routerPath: "/mom-stories" },
  { name: "Chores", routerPath: "/chores" },
  { name: "Growing Up Pictures", routerPath: "/viewPictures" },
  { name: "Sibling Newsletter", routerPath: currentNewsLetterPath },
  { name: "Timeline", routerPath: "/timeline" },
  { name: "Live Buzzer", routerPath: "/buzzer" },
  { name: "Ballpark", routerPath: "/ballpark" },
  { name: "Scattergories", routerPath: "/scattergories" },
  { name: "Just One", routerPath: "/justone" },
  { name: "CPR Metronome", routerPath: "/metronome" },
  {
    name: "Samantha Mission",
    url: "https://samantha-s-mission.web.app/",
    external: true,
  },
  { name: "Dymock History", routerPath: "/dymock-history" },
  { name: "Ancestor Converts", routerPath: "/ancestor-converts" },
]

// Flat view derived from the grouped menu — single source of truth.
// Surfaces that don't support nesting (mobile drawer, ThemeMainMenu dropdown,
// MobileMenu sidebar) consume this so they render every link as a flat list.
export const DymockFamilyMenu = DymockFamilyMenuGrouped.flatMap((item) =>
  item.children ? item.children : [item]
)
